module.exports = __webpack_public_path__ + "static/img/logo.3e2cf33.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/main/logo.png
// module id = xzZE
// module chunks = 26